import React from 'react';
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '@/components/ui/tooltip';

export default function VerifiedBadge({ show = false, size = 'md' }) {
  if (!show) return null;

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-5 h-5',
    lg: 'w-6 h-6',
    xl: 'w-7 h-7'
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <span className="inline-flex items-center">
            <img 
              src="https://customer-assets.emergentagent.com/job_edu-platform-104/artifacts/ktiin7sm_image.png"
              alt="Verified Badge"
              className={`${sizeClasses[size]} object-contain`}
            />
          </span>
        </TooltipTrigger>
        <TooltipContent className="bg-white border-2 border-primary-blue shadow-lg rounded-xl">
          <p className="text-navy font-bold">✓ Verified Profile</p>
          <p className="text-sm text-[#4D4D4D]">All required details completed</p>
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
